import React from 'react';

const  Heading2 = (props) => {

    const {
        children,
        classe,
        font,
        size
    } = props

    let fontTitle, sizeTitle
    if(font === 'primary') fontTitle = "font-primary"
    else fontTitle = "font-secondary"

    if(size==="big") sizeTitle = "text-rl"
    else sizeTitle = "text-rl"

    return (
        <h2 className={`
            ${ fontTitle }
            ${ sizeTitle }
            ${ fontTitle }
            text-xl
            md:text-2xl
            lg:text-3xl
            font-extrabold
            font-bold
            leading-snug
            text-secondary
            ${classe}
        `}>
            { children }
        </h2>
    );
}

export default Heading2;